import { create } from "zustand"

import { PurchasableItem } from "@hooks/V2/storyblok"

export const getOrderClass = (order?: number): string => {
  switch (order) {
    case 1:
      return "order-1"
    case 2:
      return "order-2"
    case 3:
      return "order-3"
    case 4:
      return "order-4"
    case 5:
      return "order-5"
    default:
      return "order-6"
  }
}

type PageLayoutState = {
  hasSiteBanner: boolean
  setHasSiteBanner: (hasBanner: boolean) => void
  hasAnchorNavigation: boolean
  setHasAnchorNavigation: (hasAnchorNavigation: boolean) => void
  heroCTAVisible: boolean
  setHeroCTAVisible: (heroCTAVisible: boolean) => void
  heroCTAPurchasableItem: PurchasableItem | null
  setHeroCTAPurchasableItem: (
    heroCTAPurchasableItem: PurchasableItem | null
  ) => void
  navigationMode: "light" | "dark"
  setNavigationMode: (mode: "light" | "dark") => void
  stickyFooterHeight: number
  calculateStickyFooterHeight: (height: number) => void
  resetStickyFooterHeight: () => void
}

export const usePageLayoutState = create<PageLayoutState>()((set) => ({
  hasSiteBanner: false,
  setHasSiteBanner: (hasBanner: boolean) => set({ hasSiteBanner: hasBanner }),
  hasAnchorNavigation: false,
  setHasAnchorNavigation: (hasAnchorNavigation: boolean) =>
    set({ hasAnchorNavigation: hasAnchorNavigation }),
  heroCTAVisible: false,
  setHeroCTAVisible: (heroCTAVisible: boolean) =>
    set({ heroCTAVisible: heroCTAVisible }),
  heroCTAPurchasableItem: null,
  setHeroCTAPurchasableItem: (heroCTAPurchasableItem: PurchasableItem | null) =>
    set({ heroCTAPurchasableItem: heroCTAPurchasableItem }),
  navigationMode: "light",
  setNavigationMode: (mode: "light" | "dark") =>
    set(() => {
      document.body.style.backgroundColor =
        mode === "light" ? "#FDFDFD" : "#222222"
      return { navigationMode: mode }
    }),
  stickyFooterHeight: 0,
  calculateStickyFooterHeight: (height: number) =>
    set((state) => {
      const newHeight = Math.max(state.stickyFooterHeight + height, 0)
      document.body.style.setProperty(
        "--sticky-footer-height",
        `${newHeight}px`
      )
      return { stickyFooterHeight: newHeight }
    }),
  resetStickyFooterHeight: () => {
    document.body.style.setProperty("--sticky-footer-height", "0px")
    return { stickyFooterHeight: 0 }
  },
}))
